// extracted by mini-css-extract-plugin
export var carrierNotice = "_m8-5";
export var carrierNoticePlaceholder = "_m8-6";
export var deliveryRow = "_m8-c";
export var fixedHeight = "_m8-4";
export var freightLogo = "_m8-b";
export var fullWidth = "_m8-3";
export var priceColumn = "_m8-7";
export var radioSelected = "_m8-9";
export var radioUnselected = "_m8-8";
export var selectedOption = "_m8-2";
export var selectedOptionContainer = "_m8-1";
export var selection = "_m8-0";
export var tallSkeletonText = "_m8-a";